import React from "react";
import { useTranslation } from "react-i18next";
import TrashIcon from "../../../assets/icons/Trash.svg";
import * as moment from "moment";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { playSong } from "../../common/actions/common.actions";
import { IoIosFootball } from "react-icons/io";

const Content = ({
  eventTime,
  homeTeam,
  awayTeam,
  bodyHandicap,
  goalHandicap,
  match,
  sendDataToParent,
  selectedMatches = [],
  fromSelectedPage = false,
  handleRemoveCard,
  isFivePercent,
  flag,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleClick = (choosen) => {
    handleSongClick();
    sendDataToParent(choosen, match);
  };

  const isSelected = selectedMatches?.some((x) => x.eventId === match.eventId);

  const isHomeChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "home"
    );

  const isAwayChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "away"
    );

  const isOverChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "over"
    );

  const isUnderChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "under"
    );

  const removeCard = async () => {
    await handleSongClick();
    handleRemoveCard(match.rapidEventId);
  };

  return (
    <li className="w-full max-w-2xl mx-auto mb-1 font-myanmarSansPro">
      {/* Card */}
      <div
        className={`rounded-2xl shadow-lg px-2 py-1 transition-all duration-300 backdrop-blur-sm border ${
          location.pathname === "/body"
            ? isFivePercent
              ? "bg-gradient-to-br from-[#FF4500]/20 to-red-100 border-[#FF4500]/30"
              : "bg-gradient-to-br from-white/80 to-[#EAEAEA]/50 border-gray-200/50"
            : "bg-gradient-to-br from-white/80 to-[#EAEAEA]/50 border-gray-200/50 hover:border-[#228B22]/30 hover:shadow-xl"
        }`}
      >
        {/* Header Info */}
        <div className="flex justify-between items-center mb-1.5">
          <div className="flex items-center gap-2 px-3 py-1 bg-[#228B22]/10 rounded-xl border border-[#228B22]/20">
            <IoIosFootball size={16} className="text-[#228B22]" />
            <span className="text-xs font-bold text-[#228B22]">{match.leagueName}</span>
          </div>
          <div className="text-right">
            {/* <p className="text-xs font-medium text-gray-600">Match Time</p> */}
            <p className="text-sm font-bold text-gray-800">
              {moment(new Date(match?.eventTime)).format("DD.MM.YYYY h:mm A")}
            </p>
          </div>
        </div>

        {/* Home & Away Teams */}
        <div
          className={`grid grid-cols-2 gap-1 mb-1 ${
            fromSelectedPage ? "pointer-events-none opacity-80" : ""
          }`}
        >
          {/* Home Team */}
          <div
            onClick={() => handleClick("home")}
            className={`p-2 rounded-xl flex justify-between items-center cursor-pointer transition-all duration-200 ${
              isHomeChosen
                ? "bg-gradient-to-r from-[#228B22] to-emerald-600 text-white shadow-lg"
                : "bg-white/80 hover:bg-white hover:border-[#228B22]/40 hover:shadow-md"
            }`}
          >
            <span className={`text-sm font-bold flex-1 text-center ${isHomeChosen ? 'text-white' : 'text-gray-800'}`}>
              {i18n.language === "en" ? match.homeTeam : match.homeTeamMyan}
            </span>
            {match.overId === match.homeId && (
              <span className="text-xs font-mono px-2 py-1 bg-[#FFD700] text-gray-900 rounded-full ml-2 font-bold whitespace-nowrap">
                {match.bodyHandicap}
              </span>
            )}
          </div>

          {/* Away Team */}
          <div
            onClick={() => handleClick("away")}
            className={`p-2 rounded-xl flex justify-between items-center cursor-pointer transition-all duration-200 ${
              isAwayChosen
                ? "bg-gradient-to-r from-[#228B22] to-emerald-600 text-white shadow-lg"
                : "bg-white/80 hover:bg-white hover:border-[#228B22]/40 hover:shadow-md"
            }`}
          >
            {match.overId === match.awayId && (
              <span className="text-xs font-mono px-2 py-1 bg-[#FFD700] text-gray-900 rounded-full mr-2 font-bold whitespace-nowrap">
                {match.bodyHandicap}
              </span>
            )}
            <span className={`text-sm font-bold flex-1 text-center ${isAwayChosen ? 'text-white' : 'text-gray-800'}`}>
              {i18n.language === "en" ? match.awayTeam : match.awayTeamMyan}
            </span>
          </div>
        </div>

        {/* Over / Odds / Under */}
        <div
          className={`grid grid-cols-5 gap-1 ${
            fromSelectedPage ? "pointer-events-none opacity-80" : ""
          }`}
        >
          {/* Over */}
          <div
            onClick={() => handleClick("over")}
            className={`col-span-2 p-1 text-center rounded-xl cursor-pointer transition-all duration-200 ${
              isOverChosen
                ? "bg-gradient-to-r from-[#1E90FF] to-blue-600 text-white shadow-lg"
                : "bg-white/80 hover:bg-white hover:border-[#1E90FF]/40 hover:shadow-md"
            }`}
          >
            <span className={`text-sm font-bold ${isOverChosen ? 'text-white' : 'text-gray-800'}`}>
              {t("goalOver")}
            </span>
          </div>

          {/* Odds */}
          <div className="p-1 bg-gradient-to-br from-[#FFD700] to-yellow-400 text-gray-900 text-sm font-bold font-mono rounded-xl flex items-center justify-center shadow-md border border-yellow-300 whitespace-nowrap">
            {match.goalHandicap}
          </div>

          {/* Under */}
          <div
            onClick={() => handleClick("under")}
            className={`col-span-2 p-1 text-center rounded-xl cursor-pointer transition-all duration-200 ${
              isUnderChosen
                ? "bg-gradient-to-r from-[#FF4500] to-red-600 text-white shadow-lg"
                : "bg-white/80 hover:bg-white hover:border-[#FF4500]/40 hover:shadow-md"
            }`}
          >
            <span className={`text-sm font-bold ${isUnderChosen ? 'text-white' : 'text-gray-800'}`}>
              {t("goalUnder")}
            </span>
          </div>
        </div>
      </div>
    </li>
  );
};

export default Content;
